import React, { FC } from 'react';
import { LabelWrapper } from './style';
import Barcode from 'react-barcode';

type Props = {
  data: any;
  nextPage: number;
};

const Label: FC<Props> = ({ data, nextPage }: Props): React.ReactElement => {
  const flatFeatures = (items: any) => {
    const features: string[] = [];
    if (items.featureValues) {
      items.featureValues.forEach(
        (el: { featureName: string; valueName: string }) => {
          features.push(`${el.featureName}: ${el.valueName}`);
        },
      );
    }
    return features;
  };
  return (
    <LabelWrapper className={`${!nextPage && 'nextPage'}`}>
      <div className="variant">
        {/* <span className='partner-info'>{(data?.partnerName + (data.sellerName ? ` (${data.sellerName})` : '')).substring(0, 45)}</span> */}
        <span className='variant-id'>{data.variantId}</span>
        <span className='product-code'>{data.productCode}</span>
        <Barcode textPosition={'top'} textAlign='left' fontOptions={'bold'} height={'30px'} fontSize={8} value={data.variantId} />
      </div>
      <div className="product">
        <span
        >
          {data.productName} {`${data?.featureValues?.length ? `-` + flatFeatures(data)?.join(',')?.slice(0, 10) : ''}`}
        </span>
      </div>
      <div className="inventory">
        <Barcode
          width={1.3}
          textAlign=""
          fontSize={9}
          value={data.serialNumber}
          height={'30px'}
          fontOptions={'bold'}
        />
      </div>
    </LabelWrapper>
  );
};

export default Label;
